module.exports = "../../app/cells/pages/contest/common_questions_cell.rb";